import React, { useEffect } from 'react';

import { Page, PageContent } from '@vlabs/monokit/shared/ui/page';
import { Pages } from '@vlabs/uikit';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

import { resetPasswordLogout, resetPassword } from '../store.js';
import { useResetPasswordPageTranslation } from './i18n.js';

export function ResetPasswordPage(): React.JSX.Element {
  const { t } = useResetPasswordPageTranslation();
  const history = useHistory();
  const { token } = useParams();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(resetPasswordLogout);
  }, [dispatch]);

  const resetHandler = async ({ password }) => {
    try {
      await resetPassword({ token, password });
      history.push('/');
    } catch (error) {
      toast.error(t('error.password_not_changed'));
    }
  };

  return (
    <Page>
      <PageContent>
        <div
          style={{
            flex: 1,
          }}
        >
          <Pages.ResetPasswordPage onSubmit={resetHandler} />
        </div>
      </PageContent>
    </Page>
  );
}
